import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-icon',
    template: '<i [ngClass]="classNames"></i>',
    styleUrls: ['./icon.component.less'],
})
export class IconComponent {
    // this component is meant to be used with custom icon which name start with 'icon-'
    @Input() name: string;
    @Input() size = 'md'; // valid values 'sm', 'md', 'lg', 'xl'
    @Input() color = '';

    get classNames() {
        return [
            this.name,
            `icon--size-${this.size}`,
            this.color ? `text-${this.color}` : ''
        ];
    }
}
